export const createAnode = (_userId, _type) => {};

// connect Firebase
export const listenToFirebaseDB = () => {};

// disconnect Firebase
export const unsubScribeFirebase = () => {};
